module.exports = __webpack_public_path__ + "static/img/zhfh06.921909a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/zhfh06.jpg
// module id = Qj/e
// module chunks = 11